import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import authenticate from '../../services/auth.service';
import { AuthRequest } from '../../requestModels/authRequest';
import { UserProfile } from '../../types/UserProfile';
import { ResponseTokens } from '../../types/Tokens';

interface SightingState {
  user: UserProfile | null;
  isLoginLoading: boolean;
  error: string;
}

const initialState: SightingState = {
  user: authenticate.getStoredUserProfile(),
  isLoginLoading: false,
  error: '',
};

export const authLogin = createAsyncThunk('auth/login', async (request: AuthRequest) => await authenticate.authenticate(request));

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateUserState: (state, action: PayloadAction<string>) => {
      state.user = authenticate.decodeAccessToken(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(authLogin.pending, (state) => {
        state.error = '';
        state.isLoginLoading = true;
      })
      .addCase(authLogin.fulfilled, (state, action: PayloadAction<ResponseTokens>) => {
        if (action.payload.status === 200) {
          try {
            const userProfile = authenticate.createUserProfile(action.payload.data);
            authenticate.setUserProfile(userProfile);
            state.user = userProfile;
          } catch (err) {
            console.error('Access token is not a valid JWT:', err);
            state.user = null; // or fallback to user info if available elsehere
          }

          state.error = '';
        } else {
          state.error = action.payload.data;
        }
        state.isLoginLoading = false;
      });
  },
});

export const { updateUserState } = authSlice.actions;
export default authSlice.reducer;
